var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIconMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4072 3.31781L11.9992 10.2418L2.59125 3.31781M1.48125 1.02581C1.16299 1.02581 0.857766 1.15224 0.632722 1.37728C0.407678 1.60233 0.28125 1.90755 0.28125 2.22581V15.7918C0.28125 16.1101 0.407678 16.4153 0.632722 16.6403C0.857766 16.8654 1.16299 16.9918 1.48125 16.9918H22.5172C22.8355 16.9918 23.1407 16.8654 23.3658 16.6403C23.5908 16.4153 23.7172 16.1101 23.7172 15.7918V2.20781C23.7172 1.88955 23.5908 1.58433 23.3658 1.35928C23.1407 1.13424 22.8355 1.00781 22.5172 1.00781H1.48125V1.02581Z",
    stroke: "#282929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconMobile);
export default __webpack_public_path__ + "static/media/email-icon-mobile.3a263df8.svg";
export { ForwardRef as ReactComponent };